"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const customer_entity_1 = require("./customer.entity");
const address_entity_1 = require("./address.entity");
const interaction_log_entity_1 = require("./interaction-log.entity");
const customers_service_1 = require("./customers.service");
const customers_controller_1 = require("./customers.controller");
let CustomersModule = class CustomersModule {
};
exports.CustomersModule = CustomersModule;
exports.CustomersModule = CustomersModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([customer_entity_1.Customer, address_entity_1.Address, interaction_log_entity_1.InteractionLog])],
        providers: [customers_service_1.CustomersService],
        controllers: [customers_controller_1.CustomersController],
        exports: [customers_service_1.CustomersService],
    })
], CustomersModule);
